var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSweden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.578 511.999C397.963 511.999 512.578 397.384 512.578 255.999C512.578 114.614 397.963 -0.000976562 256.578 -0.000976562C115.193 -0.000976562 0.578125 114.614 0.578125 255.999C0.578125 397.384 115.193 511.999 256.578 511.999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.927 222.608H510.411C494.048 97.001 386.645 -0.000976562 256.578 -0.000976562C237.464 -0.000976562 218.845 2.11202 200.926 6.08402V222.608H200.927Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.143 222.607V31.126C63.8491 69.48 13.5281 139.831 2.74512 222.608H134.143V222.607Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.142 289.39H2.74512C13.5281 372.167 63.8491 442.518 134.143 480.871L134.142 289.39Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.926 289.391V505.914C218.845 509.886 237.464 511.999 256.578 511.999C386.645 511.999 494.048 414.997 510.411 289.39H200.926V289.391Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.578125 -0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden);
export default __webpack_public_path__ + "static/media/sweden.915e8035714659282e5a5b99a5f5c641.svg";
export { ForwardRef as ReactComponent };